import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import { BlogListQuery_allMdx_edges_node } from "../templates/__generated__/BlogListQuery"
import { IndexPageQuery_blog_edges_node } from "../pages/__generated__/IndexPageQuery"

type ItemBlogProps = BlogListQuery_allMdx_edges_node | IndexPageQuery_blog_edges_node
export const ItemBlog: React.FC<{ data: ItemBlogProps }> = ({ data }) => {
    return (
        <article className="blog-item w-full md:w-1/2 lg:w-1/3 px-4 mb-12">
            <Link
                to={data.fields.slug}
                title={data.frontmatter.title}
                className="block h-full"
            >
                <div className="card flex flex-col h-full">
                    <div className="card-media">
                        <Img
                            fluid={data.frontmatter.image.childImageSharp.fluid}
                            alt={data.frontmatter.title}
                            className="w-full"
                            style={{ height: "15rem" }}
                            imgStyle={{ objectFit: "cover" }}
                        />
                    </div>
                    <div className="flex flex-col flex-1 p-8">
                        <p className="meta">{data.frontmatter.date}</p>
                        <h3 className="card-title display-4 text-color-1 mt-4">
                            {data.frontmatter.title}
                        </h3>
                        <p className="mt-4 text-color-2 text-base flex-1">
                            {data.frontmatter.description}
                        </p>
                        <span className="link-quiet mt-8 self-start">
                            Czytaj dalej
                        </span>
                    </div>
                </div>
            </Link>
        </article>
    )
}

export default ItemBlog
